/* Siete Notas — carrito: comprobante de pago (boleta o factura)
   - Lo usa snippets/sn-comprobante.liquid (página del carrito y carrito lateral).
   - Guarda Comprobante, Documento y Razón social como atributos del carrito con
     /cart/update.js y los copia en campos ocultos del formulario del carrito
     (respaldo por si el cliente pulsa "Pagar" antes de que termine el guardado).
   - Nunca bloquea el botón de pago: solo avisa si un dato está mal. */
(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('sn-comprobante')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PESOS_RUC = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

  var MSG = {
    dni: 'El DNI tiene 8 dígitos. Revísalo, por favor.',
    ce: 'El carné de extranjería debe tener entre 6 y 12 letras o números.',
    pas: 'El pasaporte debe tener entre 6 y 12 letras o números.',
    docFalta: 'Tu compra pasa de S/ 700: escribe tu número de documento para la boleta.',
    rucFalta: 'Escribe el RUC al que emitiremos la factura.',
    ruc: 'Ese RUC no es válido. Revisa que tenga los 11 dígitos correctos.',
    rsFalta: 'Escribe la razón social tal como figura en SUNAT.',
    red: 'No pudimos guardar los datos de tu comprobante. Revisa tu conexión e inténtalo otra vez.'
  };

  function soloDigitos(v) { return String(v || '').replace(/\D+/g, ''); }
  function limpiarAlfanum(v) { return String(v || '').replace(/[^0-9a-z]/gi, '').toUpperCase(); }
  function limpiarTexto(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }

  /* RUC: 11 dígitos, empieza en 10, 15, 16, 17 o 20 y cumple el dígito verificador (módulo 11 de SUNAT). */
  function rucValido(ruc) {
    if (!/^(10|15|16|17|20)\d{9}$/.test(ruc)) return false;
    var suma = 0;
    for (var i = 0; i < 10; i++) suma += Number(ruc.charAt(i)) * PESOS_RUC[i];
    var dv = 11 - (suma % 11);
    if (dv === 10) dv = 0;
    if (dv === 11) dv = 1;
    return dv === Number(ruc.charAt(10));
  }

  /* DNI: 8 dígitos. Carné de extranjería y pasaporte: de 6 a 12 letras o números. */
  function docValido(tipo, numero) {
    return tipo === 'DNI' ? /^\d{8}$/.test(numero) : /^[0-9A-Z]{6,12}$/.test(numero);
  }

  class SnComprobante extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      this._listo = true;
      this._cola = Promise.resolve();
      this._timer = 0;
      this._tocados = {};

      /* Marca que el componente ya está activo. El servidor nunca la envía, así el
         carrito de Horizon no confunde este bloque con la versión recién renderizada. */
      this.setAttribute('data-sn-ready', '');

      this.querySelectorAll('[data-sn-campo]').forEach(function (input) {
        input._snAyuda = input.getAttribute('aria-describedby') || '';
      });

      this.addEventListener('change', this);
      this.addEventListener('input', this);

      this.aplicarTipo(this.tipo());
      this.ajustarDocumento();
      var datos = this.datos();
      this.escribirOcultos(datos);
      this.actualizarResumen(datos);
      this._ultimo = JSON.stringify(datos);
    }

    disconnectedCallback() {
      /* Si quedaba un guardado pendiente, se envía ya. */
      if (this._timer) this.guardar();
    }

    handleEvent(e) {
      var t = e.target;
      if (!(t instanceof HTMLElement)) return;

      if (e.type === 'change') {
        if (t.matches('[data-sn-tipo]')) {
          this.aplicarTipo(this.tipo());
          this.validar();
        } else if (t.matches('[data-sn-doc-tipo]')) {
          this.ajustarDocumento();
          if (this.campo('doc') && this.campo('doc').value) this._tocados.doc = true;
          this.validar();
        } else if (t.matches('[data-sn-campo]')) {
          this.normalizar(t);
          this._tocados[t.getAttribute('data-sn-campo')] = true;
          this.validar();
        }
        this.guardar();
        return;
      }

      if (e.type === 'input' && t.matches('[data-sn-campo]')) {
        this.validar();
        clearTimeout(this._timer);
        var self = this;
        this._timer = setTimeout(function () { self.guardar(); }, 800);
      }
    }

    campo(nombre) { return this.querySelector('[data-sn-campo="' + nombre + '"]'); }

    tipo() {
      var r = this.querySelector('[data-sn-tipo]:checked');
      return r && r.value === 'Factura' ? 'Factura' : 'Boleta';
    }

    tipoDoc() {
      var s = this.querySelector('[data-sn-doc-tipo]');
      var v = s ? s.value : '';
      return v === 'CE' || v === 'Pasaporte' ? v : 'DNI';
    }

    numeroDoc() {
      var input = this.campo('doc');
      if (!input) return '';
      return this.tipoDoc() === 'DNI' ? soloDigitos(input.value) : limpiarAlfanum(input.value);
    }

    /* El aviso de S/ 700 está fuera de este bloque y Horizon lo actualiza solo. */
    pasa700() {
      var aviso = this.parentElement && this.parentElement.querySelector('[data-sn-aviso700]');
      return !!aviso && !aviso.hidden;
    }

    aplicarTipo(tipo) {
      this.setAttribute('data-tipo', tipo);
      this.querySelectorAll('[data-sn-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-sn-panel') !== tipo;
      });
    }

    ajustarDocumento() {
      var input = this.campo('doc');
      if (!input) return;
      input.setAttribute('inputmode', this.tipoDoc() === 'DNI' ? 'numeric' : 'text');
    }

    normalizar(input) {
      var nombre = input.getAttribute('data-sn-campo');
      var limpio = input.value;
      if (nombre === 'doc') limpio = this.numeroDoc();
      else if (nombre === 'ruc') limpio = soloDigitos(input.value);
      else if (nombre === 'rs') limpio = limpiarTexto(input.value);
      if (limpio !== input.value) input.value = limpio;
    }

    validar() {
      if (this.tipo() === 'Boleta') {
        var td = this.tipoDoc();
        var num = this.numeroDoc();
        var errDoc = '';
        if (!num) errDoc = this.pasa700() ? MSG.docFalta : '';
        else if (!docValido(td, num)) errDoc = td === 'DNI' ? MSG.dni : (td === 'CE' ? MSG.ce : MSG.pas);
        this.marcar('doc', errDoc);
        this.marcar('ruc', '');
        this.marcar('rs', '');
      } else {
        var ruc = soloDigitos(this.campo('ruc') && this.campo('ruc').value);
        var rs = limpiarTexto(this.campo('rs') && this.campo('rs').value);
        this.marcar('ruc', !ruc ? MSG.rucFalta : (rucValido(ruc) ? '' : MSG.ruc));
        this.marcar('rs', rs.length >= 3 ? '' : MSG.rsFalta);
        this.marcar('doc', '');
      }
    }

    /* Muestra el error solo si el cliente ya pasó por ese campo (o si ya se veía). */
    marcar(nombre, mensaje) {
      var input = this.campo(nombre);
      var error = this.querySelector('[data-sn-error="' + nombre + '"]');
      if (!input || !error) return;
      var yaVisible = !error.hidden;

      if (mensaje && (this._tocados[nombre] || yaVisible)) {
        error.textContent = mensaje;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', (error.id + ' ' + (input._snAyuda || '')).trim());
      } else if (!mensaje) {
        error.textContent = '';
        error.hidden = true;
        input.removeAttribute('aria-invalid');
        if (input._snAyuda) input.setAttribute('aria-describedby', input._snAyuda);
        else input.removeAttribute('aria-describedby');
      }
    }

    /* Lo que se guarda: solo datos válidos. Si algo está mal, ese campo va vacío. */
    datos() {
      var tipo = this.tipo();
      var d = { 'Comprobante': tipo, 'Documento': '', 'Razón social': '' };
      if (tipo === 'Boleta') {
        var td = this.tipoDoc();
        var num = this.numeroDoc();
        if (num && docValido(td, num)) d['Documento'] = td + ' ' + num;
      } else {
        var ruc = soloDigitos(this.campo('ruc') && this.campo('ruc').value);
        var rs = limpiarTexto(this.campo('rs') && this.campo('rs').value);
        if (rucValido(ruc)) d['Documento'] = 'RUC ' + ruc;
        if (rs.length >= 3) d['Razón social'] = rs;
      }
      return d;
    }

    escribirOcultos(d) {
      this.querySelectorAll('[data-sn-attr]').forEach(function (input) {
        input.value = d[input.getAttribute('data-sn-attr')] || '';
      });
    }

    actualizarResumen(d) {
      var el = this.querySelector('[data-sn-resumen]');
      if (!el) return;
      var texto;
      if (d['Comprobante'] === 'Factura') {
        texto = d['Documento'] ? 'Factura · ' + d['Documento'] : 'Factura (faltan datos)';
      } else {
        texto = d['Documento'] ? 'Boleta con ' + d['Documento'].split(' ')[0] : 'Boleta';
      }
      if (el.textContent !== texto) el.textContent = texto;
    }

    avisar(mensaje) {
      var el = this.querySelector('[data-sn-status]');
      if (el && el.textContent !== mensaje) el.textContent = mensaje;
    }

    guardar() {
      clearTimeout(this._timer);
      this._timer = 0;

      var d = this.datos();
      this.escribirOcultos(d);
      this.actualizarResumen(d);

      var clave = JSON.stringify(d);
      if (clave === this._ultimo) return;
      this._ultimo = clave;

      var self = this;
      this._cola = this._cola
        .then(function () {
          return fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: d }),
            keepalive: true
          }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            self.avisar('');
          });
        })
        .catch(function () {
          self._ultimo = '';
          self.avisar(MSG.red);
        });
    }
  }

  customElements.define('sn-comprobante', SnComprobante);

  /* Solo para pruebas internas (no afecta a la tienda). */
  window.SNComprobante = { rucValido: rucValido, docValido: docValido };
})();
